module.exports = __webpack_public_path__ + "img/background.jpg?14521bc95bfe16c883eba6177f8d272c";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/src/assets/img/background.jpg
// module id = 63
// module chunks = 0